export default __webpack_public_path__ + "static/media/empty_profile.d94d81af.svg";